import { type Money } from '@/utils/formatter'
import { useFormatter } from '@/utils/useFormatter'

/**
 * Style-agnostic wrapper that renders a monthly price with an accessible label.
 * Visually displays the abbreviated format (e.g. "110 kr/mån") while providing
 * an unabbreviated aria-label for screen readers (e.g. "110 kr per månad").
 *
 * For styled price displays with strikethrough support, use `Price` instead.
 */
type AccessiblePriceProps = {
  price: Money
  prefix?: string
}

export function AccessiblePrice({ price, prefix = '' }: AccessiblePriceProps) {
  const formatter = useFormatter()
  const visual = `${prefix}${formatter.monthlyPrice(price)}`
  const accessible = `${prefix}${formatter.monthlyPriceAccessible(price)}`
  return (
    <span role="text" aria-label={accessible}>
      <span aria-hidden={true}>{visual}</span>
    </span>
  )
}
